module.exports = __webpack_public_path__ + "static/media/zip.3df63985.svg";